import { routerMiddleware as createRouterMiddleware } from 'connected-react-router'
import createHistory from 'history/createBrowserHistory'
import { applyMiddleware, compose, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import { createLogger } from 'redux-logger'
import { createStateSyncMiddleware } from 'redux-state-sync'
import thunkMiddleware from 'redux-thunk'

import createRootReducer from 'src/store/modules'

import { ACTION_WHITE_LIST } from 'src/constants'

import check2faMiddleware from './middlewares/check2faMiddleware'

const combineStoreAndHistory = (initialState, history) => {
  const loggerConfig = {
    collapsed: true
  }
  const syncConfig = {
    whitelist: ACTION_WHITE_LIST
  }

  const loggerMiddleware = createLogger(loggerConfig)
  const routerMiddleware = createRouterMiddleware(history)
  const stateSyncMiddleware = createStateSyncMiddleware(syncConfig)

  const middlewares = [
    thunkMiddleware,
    routerMiddleware,
    stateSyncMiddleware,
    check2faMiddleware
  ]
  const isDevEnv = process.env.NODE_ENV === 'development'

  // Redux DevTools is a development-only tool. Outside development use plain
  // `compose`, otherwise every action pays for the extension hook (and, with
  // `trace`, a stack capture). In development `trace` is opt-in
  // (`--env REDUX_TRACE=true`) because capturing a 50-frame stack on every
  // action is expensive and distorts profiling.
  const enhancer = isDevEnv
    ? composeWithDevTools({
        trace: Boolean(process.env.REDUX_TRACE),
        traceLimit: 50
      })
    : compose

  if (isDevEnv) middlewares.push(loggerMiddleware)

  return createStore(
    createRootReducer(history),
    initialState,
    enhancer(applyMiddleware(...middlewares))
  )
}

const initialState = {}

export const history = createHistory()
export const store = combineStoreAndHistory(initialState, history)
